angular.module('tf.directives')
    .directive('noFarmersGalleryItem', ['$state', function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            templateUrl: 'js/components/noFarmersGalleryItem/noFarmersGalleryItem.html',
            controller: 'NoFarmersGalleryItemController'
        };
    }])
    .controller('NoFarmersGalleryItemController', ['$scope',function($scope) {
        $scope.defaultImage = "../img/no-templates.svg";
    }]);
    